import { loadStripe, type Stripe } from "@stripe/stripe-js";

import {
  paymentsClientToken,
  paymentsConfigured as configured,
  paymentsEnvironment,
  type PaymentsEnv,
} from "@/lib/payments-env";

let stripePromise: Promise<Stripe | null> | null = null;

export function getStripe(): Promise<Stripe | null> {
  if (!stripePromise) {
    paymentsEnvironment();
    stripePromise = loadStripe(paymentsClientToken() as string);
  }
  return stripePromise;
}

export function getStripeEnvironment(): PaymentsEnv {
  return paymentsEnvironment();
}

export function paymentsConfigured(): boolean {
  return configured();
}
